import { chakra, Box, Separator, Heading, List, Text, VStack } from '@chakra-ui/react'
import { NewsletterSubscribeForm } from '@src/components/sco/NewsletterSubscribeForm'
import { SEOMetadata } from '@src/components/sco/utilities/SEOMetadata'
import { PageWithNavBar } from '@src/templates/PageWithNavBar'

export default function Page() {
  return (
    <PageWithNavBar>
      <VStack align={'center'} justify={'center'} minHeight={'85vh'} width={'full'}>
        <Box maxWidth={'680px'} width={'full'}>
          <VStack align={'stretch'} gap={4} padding={'1em'}>
            <Heading size={'3xl'} textAlign={'center'}>
              The Startups.com Newsletter
            </Heading>
            <Text fontSize={'1.25em'} textAlign={'center'}>
              Get 4 weekly videos from multi-million dollar founders revealing how to raise funding, validate
              {'ideas, get customers, navigate mental roadblocks, and all things startups.'}{' '}
              <chakra.strong color={'white'} fontStyle={'italic'}>
                Trusted by over 250,000 founders.
              </chakra.strong>
            </Text>
            <Separator marginY={'0.5em'} />
            <List.Root gap={'1em'} listStyleType={'circle'} paddingLeft={'1em'}>
              <List.Item>
                <Text fontSize={'1.125em'}>{'We don&rsquo;t believe in theoretical or generic advice.'}</Text>
              </List.Item>
              <List.Item>
                <Text fontSize={'1.125em'}>
                  Only unique experience-based insights from founders who&rsquo; ve built and funded
                  multi-million dollar companies to help you do the same :)
                </Text>
              </List.Item>
              <List.Item>
                <Text fontSize={'1.125em'}>
                  None of the videos we share are click-bait pulp. You&rsquo; ll be consuming niche content
                  that other people aren&rsquo;t, so you can get results that other people don&rsquo;t.
                </Text>
              </List.Item>
            </List.Root>

            <Box paddingY={'1em'} width={'full'}>
              <NewsletterSubscribeForm
                containerProps={{ bgColor: '#49479D' }}
                inputProps={{ colorPalette: 'whiteAlpha' }}
              />
            </Box>
          </VStack>
        </Box>
      </VStack>
      <SEOMetadata description={'Weekly videos from multi-million dollar founders.'} title={'Newsletter'} />
    </PageWithNavBar>
  )
}
